<header class="flex align-items-center gap-2 p-3 border-bottom-1 surface-border">
  @if (mostrarVolver()) {
    <span class="md:hidden">
      <p-button
        type="button"
        icon="pi pi-arrow-left"
        styleClass="p-button-text p-button-sm"
        ariaLabel="Volver a la lista de chats"
        (onClick)="volver.emit()"
      />
    </span>
  }

  <p-avatar
    [label]="iniciales()"
    shape="circle"
    [style]="avatarStyle()"
    [image]="conversacion().img ?? undefined"
    [ariaLabel]="nombreCompleto()"
  />

  <div class="flex-1 min-w-0 flex flex-column gap-1">
    <div class="flex align-items-center gap-2 flex-wrap">
      <a
        [routerLink]="['/perfil', conversacion().personaId]"
        class="font-semibold text-color no-underline"
      >
        {{ nombreCompleto() }}
      </a>

      @if (mostrarNivel()) {
        <p-tag
          [value]="'Nivel ' + conversacion().nivelPersonal"
          severity="info"
          [rounded]="true"
        />
      }

      @if (cumpleLabel()) {
        <span class="text-xs text-color-secondary">
          <i class="pi pi-gift mr-1" aria-hidden="true"></i>{{ cumpleLabel() }}
        </span>
      }
    </div>

    @if (mostrarEdad()) {
      @if (edadLabel()) {
        <span class="text-xs text-color-secondary">{{ edadLabel() }}</span>
      }
    } @else {
      <span class="text-xs text-color-secondary white-space-nowrap overflow-hidden text-overflow-ellipsis">
        L&iacute;der: {{ liderLabel() }}
      </span>
    }
  </div>

  <ng-content />

  @if (mostrarCerrar()) {
    <p-button
      type="button"
      icon="pi pi-times"
      styleClass="p-button-text p-button-sm"
      ariaLabel="Cerrar chat"
      pTooltip="Cerrar chat"
      tooltipPosition="left"
      (onClick)="cerrar.emit()"
    />
  }
</header>
